import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themetwo/icon-search.png'


const _hoisted_1 = ["src"]

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router';
import NoticePopup from './noticePopup.vue';
import { useUserStore } from '@/stores/user';
import { openPopup, safeNavigate } from '@/view/home/supportScript';
import GameSearchPopup from './gameSearchPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'noticeBar',
  props: {
    itemData: {}
  },
  emits: ['goToGameSearch'],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore()
const router = useRouter()
const newsBarStyle = ref(
    {
        background_color: "",
        font_color: "",
        icon_color: ""
    }
)
const letIconImage = ref()
const NoticePopupRef = ref();
const gameSearchPopRef = ref()
const props = __props
const emits = __emit

const newsText = computed(() => {
    const text = props.itemData.text
    if (typeof text === 'string') return text
    const lang = localStorage.getItem('lang') || 'en'
    return text[lang] || text['en'] || ''
})

const openNoticePopup = () => {
    openPopup(NoticePopupRef)
}
const goToMessage = (event: Event) => {
    safeNavigate(router, '/sd-message', event)
}
const openGameSearchPopup = () => {
    // openPopup(gameSearchPopRef)
    emits('goToGameSearch')
}
onMounted(() => {
    newsBarStyle.value.background_color = props.itemData.styles.background_color
    newsBarStyle.value.font_color = props.itemData.styles.font_color
    newsBarStyle.value.icon_color = props.itemData.styles.icon_color
    letIconImage.value = props.itemData.leftIcon_url

})

return (_ctx: any,_cache: any) => {
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "21" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_notice_bar, {
              onClick: openNoticePopup,
              class: "notice_container",
              style: _normalizeStyle({ background: newsBarStyle.value.background_color }),
              color: newsBarStyle.value.font_color,
              text: newsText.value,
              speed: "50"
            }, {
              "left-icon": _withCtx(() => [
                _createElementVNode("img", {
                  src: letIconImage.value,
                  alt: ""
                }, null, 8, _hoisted_1)
              ]),
              _: 1
            }, 8, ["style", "color", "text"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "3" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "searchBtn",
              style: _normalizeStyle({ background: newsBarStyle.value.background_color }),
              onClick: openGameSearchPopup
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ]), 4)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(NoticePopup, {
      ref_key: "NoticePopupRef",
      ref: NoticePopupRef
    }, null, 512),
    _createVNode(GameSearchPopup, {
      ref_key: "gameSearchPopRef",
      ref: gameSearchPopRef
    }, null, 512)
  ], 64))
}
}

})